(() => {
  const root = document.querySelector('[data-vagavi-cookie]');
  const documentRoot = document.documentElement;

  const releaseNativeBanner = () => {
    documentRoot.classList.remove('vagavi-cookie-booting', 'vagavi-cookie-active');
  };

  if (!root || !window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
    releaseNativeBanner();
    return;
  }

  const banner = root.querySelector('[data-vagavi-cookie-banner]');
  const drawer = root.querySelector('[data-vagavi-cookie-drawer]');
  const scrim = root.querySelector('[data-vagavi-cookie-scrim]');
  const stateLabels = root.querySelector('[data-vagavi-cookie-on]');
  const inputs = Object.fromEntries(
    [...root.querySelectorAll('[data-vagavi-cookie-input]')].map((input) => [input.dataset.vagaviCookieInput, input])
  );
  const saveButtons = [...root.querySelectorAll('[data-vagavi-cookie-accept], [data-vagavi-cookie-reject], [data-vagavi-cookie-save]')];
  let privacy;
  let previousFocus;
  let saving = false;

  const updateStateLabels = () => {
    Object.entries(inputs).forEach(([category, input]) => {
      const label = root.querySelector(`[data-vagavi-cookie-state="${category}"]`);
      label.textContent = input.checked ? stateLabels.dataset.vagaviCookieOn : stateLabels.dataset.vagaviCookieOff;
    });
  };

  const loadChoices = () => {
    const consent = privacy.currentVisitorConsent();
    Object.entries(inputs).forEach(([category, input]) => {
      input.checked = consent[category] === 'yes';
    });
    updateStateLabels();
    return consent;
  };

  const showError = (visible) => {
    root.querySelectorAll('[data-vagavi-cookie-error]').forEach((error) => {
      error.hidden = !visible;
    });
  };

  const closeDrawer = (restoreFocus = true) => {
    const wasOpen = drawer.classList.contains('is-open');
    drawer.classList.remove('is-open');
    scrim.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.inert = true;
    banner.inert = false;
    document.body.classList.remove('vagavi-cookie-drawer-open');
    const returnFocus = previousFocus && previousFocus.getClientRects().length
      ? previousFocus
      : document.querySelector('.vagavi-cookie-footer-link');
    previousFocus = null;
    if (wasOpen && restoreFocus && returnFocus) returnFocus.focus({ preventScroll: true });
  };

  const openDrawer = (trigger) => {
    if (!privacy) return;
    previousFocus = trigger;
    loadChoices();
    showError(false);
    banner.inert = true;
    drawer.inert = false;
    drawer.setAttribute('aria-hidden', 'false');
    drawer.classList.add('is-open');
    scrim.classList.add('is-open');
    document.body.classList.add('vagavi-cookie-drawer-open');
    const closeButton = drawer.querySelector('[data-vagavi-cookie-close]');
    closeButton.focus();
    // The theme can move focus after the click handler; restore it once that
    // event has finished, even when animation frames are paused in a background tab.
    window.setTimeout(() => {
      if (drawer.classList.contains('is-open') && !drawer.contains(document.activeElement)) {
        closeButton.focus();
      }
    }, 100);
  };

  const recordChoice = (choice) => {
    if (!privacy || saving) return;
    const focusedButton = saveButtons.find((button) => button === document.activeElement);
    const showSaveError = () => {
      showError(true);
      // Disabling the submit button can move focus to the body. Restore it only
      // if the visitor has not moved focus elsewhere or closed the drawer.
      if (focusedButton && document.activeElement === document.body
        && !focusedButton.closest('[inert]') && focusedButton.getClientRects().length) {
        focusedButton.focus({ preventScroll: true });
      }
    };
    saving = true;
    showError(false);
    saveButtons.forEach((button) => { button.disabled = true; });
    try {
      privacy.setTrackingConsent(choice, (result) => {
        saving = false;
        saveButtons.forEach((button) => { button.disabled = false; });
        if (result && result.error) {
          showSaveError();
          return;
        }
        banner.hidden = true;
        closeDrawer();
        loadChoices();
      });
    } catch (error) {
      saving = false;
      saveButtons.forEach((button) => { button.disabled = false; });
      showSaveError();
    }
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-vagavi-cookie-open]');
    if (button) openDrawer(button);
  });

  root.querySelectorAll('[data-vagavi-cookie-accept]').forEach((button) => {
    button.addEventListener('click', () => recordChoice({ analytics: true, marketing: true, preferences: true }));
  });

  root.querySelector('[data-vagavi-cookie-reject]').addEventListener('click', () => {
    recordChoice({ analytics: false, marketing: false, preferences: false });
  });

  root.querySelector('[data-vagavi-cookie-save]').addEventListener('click', () => {
    recordChoice(Object.fromEntries(Object.entries(inputs).map(([category, input]) => [category, input.checked])));
  });

  root.querySelector('[data-vagavi-cookie-close]').addEventListener('click', () => closeDrawer());
  scrim.addEventListener('click', () => closeDrawer());
  Object.values(inputs).forEach((input) => input.addEventListener('change', updateStateLabels));

  drawer.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeDrawer();
      return;
    }
    if (event.key !== 'Tab') return;
    const focusable = [...drawer.querySelectorAll('a[href], button:not(:disabled), input:not(:disabled)')];
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
    if (error || !window.Shopify.customerPrivacy) {
      releaseNativeBanner();
      return;
    }
    try {
      privacy = window.Shopify.customerPrivacy;
      const consent = loadChoices();
      const hasCompleteDecision = Object.keys(inputs).every((category) => consent[category] === 'yes' || consent[category] === 'no');
      const preview = new URLSearchParams(window.location.search).get('vagavi_cookie_preview') === '1';
      banner.hidden = !preview && (!privacy.shouldShowBanner() || hasCompleteDecision);
      documentRoot.classList.add('vagavi-cookie-active');
      documentRoot.classList.remove('vagavi-cookie-booting');
    } catch (loadError) {
      privacy = null;
      banner.hidden = true;
      releaseNativeBanner();
    }
  });
})();
